import {
  StockDeliveryItem,
  StockDeliveryQuery,
  StockDeliveryResponse,
} from '../Model/stockDeliveryXModel'
import { cashReconciliationBXService } from './cashReconciliationBXService'
import { formatReportDate } from '../Utils/stationOperations'

export const stockDeliveryBXService = {
  list: async (query: StockDeliveryQuery): Promise<StockDeliveryResponse> => {
    const response = await cashReconciliationBXService.listStockDeliveries(query)
    return {
      data: (response.data.data ?? []).map((delivery): StockDeliveryItem => ({
        id: delivery.resourceId,
        reportId: delivery.reportResourceId,
        station: delivery.stationName || delivery.stationId,
        product: delivery.product,
        depotInvoiceQty: delivery.invoicedQuantity ?? null,
        quantityReceived: delivery.receivedQuantity ?? null,
        truckSiding: delivery.truckSidingVolume ?? null,
        date: formatReportDate(delivery.deliveryDate),
        status: delivery.status === 'VERIFIED' ? 'Verified' : 'Logged',
      })),
      total: response.data.meta?.total ?? response.data.data?.length ?? 0,
      page: response.data.meta?.page ?? query.page,
      limit: response.data.meta?.limit ?? query.limit,
    }
  },
}
